import Waveform from './waveform'

export default Waveform
